import classNames from "classnames";
import { ReactNode } from "react";
import KuikaSmallMediumText from "../../../../ui-kit/typography/SmallMediumText/SmallMediumText";
import ResetChangesPopover from "../reset-changes-popover/reset-changes-popover";

interface StyleLabelProps {
  fieldPaths: string[];
  section: string;
  children: ReactNode;
  className?: string;
  hasValue: boolean;
  onReset: (fieldPaths: string[]) => void;
  disabled?: boolean;
}

const StyleLabel = ({ fieldPaths, section, children, className, hasValue, onReset, disabled }: StyleLabelProps) => {
  const handleReset = () => {
    onReset(fieldPaths);
  };

  const handleLabelClick = (e: React.MouseEvent) => {
    if (e.altKey || e.metaKey) {
      e.stopPropagation();
      onReset(fieldPaths);
    }
  };

  return (
    <div className={classNames("kuika-styling-panel__label-wrapper", { disabled })} onClick={handleLabelClick}>
      {hasValue ? (
        <ResetChangesPopover onReset={handleReset} section={section} showIndicator={false}>
          <KuikaSmallMediumText onClick={handleLabelClick} className={className}>
            {children}
          </KuikaSmallMediumText>
        </ResetChangesPopover>
      ) : (
        <KuikaSmallMediumText className={className}>{children}</KuikaSmallMediumText>
      )}
    </div>
  );
};

export default StyleLabel;
